import React from "react";
import styled from "styled-components";
import HotelIcon from "@mui/icons-material/Hotel";
import StraightenIcon from "@mui/icons-material/Straighten";
import ShowerIcon from "@mui/icons-material/Shower";

const EstateSubDetails = ({ estate }) => {
  const { rooms, area, bathRooms, energyClass } = estate;
  const getNumber = (nbr) => (!!nbr ? nbr : 0);

  return (
    <StyleWrapper className="sub-details d-flex align-items-center">
      <div className="sub-detail__item">
        <HotelIcon htmlColor="var(--blue-dark)" />
        <span>{getNumber(rooms)}</span>
      </div>
      <div className="sub-detail__item">
        <StraightenIcon htmlColor="var(--blue-dark)" />
        <span>{getNumber(area)} m²</span>
      </div>
      <div className="sub-detail__item">
        <ShowerIcon htmlColor="var(--blue-dark)" />
        <span>{getNumber(bathRooms)}</span>
      </div>
      {!!energyClass && (
        <div className="sub-detail__item energy-class">PEB {energyClass}</div>
      )}
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  .sub-detail__item {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: var(--light-grey-text);
    padding: 2px 15px;

    svg {
      height: 16px;
    }

    &:not(:last-child) {
      border-right: 1px solid var(--menu-active-color);
    }
  }

  .energy-class {
    font-weight: 700;
  }
`;

export default EstateSubDetails;
